import React from "react"
import { Footer, SEO, Layout, Hero } from "@components"
import Options from "@components/pages/support/Options.js"
import { StaticImage } from "gatsby-plugin-image"
import { webPageSchema, breadcrumbSchema, HOME_CRUMB } from "@utils/schema"

const TITLE = "Dynobase Support: Setup, Billing and Licenses"
const DESCRIPTION =
  "Get help with Dynobase setup, AWS profiles, local DynamoDB connections, billing, and licenses. Find troubleshooting guides and contact support."

const SupportPage = () => {
  return (
    <>
      <Layout>
        <SEO
          title={TITLE}
          description={DESCRIPTION}
          canonical="https://dynobase.dev/support/"
          jsonLd={[
            webPageSchema({
              name: TITLE,
              description: DESCRIPTION,
              path: "/support/",
            }),
            breadcrumbSchema([HOME_CRUMB, { name: "Dynobase Support" }]),
          ]}
        />
        <div
          style={{
            margin: "auto",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Hero title="Dynobase product and sales support" />

          <StaticImage
            src={"../images/support.png"}
            placeholder="none"
            alt="Support illustration"
            style={{
              height: "300px",
              width: "300px",
              transform: "scaleX(-1)",
            }}
          />
          <h2 style={{ fontSize: "2.5em" }}>We're here to help</h2>
          <h3
            style={{
              color: "#999",
              fontWeight: 400,
              fontSize: "1.25em",
              textAlign: "center",
            }}
          >
            Email support@dynobase.dev for setup, license, or billing help
          </h3>

          <Options />

          <a href="/dynobase-and-aws-sso/" style={{ marginTop: "25px" }}>
            Troubleshoot IAM Identity Center (SSO) profiles
          </a>
          <a href="/run-dynamodb-locally/#in-dynobase">
            Connect to DynamoDB Local or LocalStack
          </a>

          <section style={{ maxWidth: "760px", margin: "40px 24px 0" }}>
            <h2>Troubleshoot before contacting support</h2>
            <p>
              If the app is slow to open or stays on the loading screen, follow our{" "}
              <a href="/dynobase-profiles-loading-slow/">profile-loading troubleshooting guide</a>.
              It covers checking AWS connectivity, limiting the profiles and regions
              loaded at startup, and resolving local DynamoDB port conflicts.
            </p>
            <h2>What to include in your message</h2>
            <p>
              Tell us your Dynobase version, operating system, and the steps that lead
              to the problem. Include the exact error message and whether it affects
              one table, one AWS profile, or every connection. For a display problem,
              a screenshot of the affected area helps us understand what happened.
            </p>
            <p>
              Remove AWS credentials, tokens, and sensitive table data before sending
              logs or screenshots. For billing or license questions, describe the
              issue and use the email address associated with your purchase.
            </p>
          </section>
          <Footer />
        </div>
      </Layout>
    </>
  )
}

export default SupportPage
